module.exports = __webpack_public_path__ + "img/虚线.6a38b50f.svg";